import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mm-blog-two',
  templateUrl: './mm-blog-two.component.html',
  styleUrls: ['./mm-blog-two.component.css']
})
export class MmBlogTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
